import { defineComponent as _defineComponent } from 'vue'
import Card from "./Card.vue"
import { PriceService } from "@/services/price-service"
import config from "@/config"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import format from "@/utils/format"

interface ChargerPricesProps {
  acChargerBaseOfCalculation: string
  acChargerPrice: number
  currency: string
  dcChargerBaseOfCalculation: string
  dcChargerPrice: number
  prepayAmount?: number
  rapidChargerBaseOfCalculation: string
  rapidChargerPrice: number
  validFrom: string
  hideRegistrationCharge: boolean
  guestCommission?: number
  registrationCharge?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChargingPrices',
  props: {
    acChargerBaseOfCalculation: { default: "" },
    acChargerPrice: { default: 0 },
    currency: { default: "" },
    dcChargerBaseOfCalculation: { default: "" },
    dcChargerPrice: { default: 0 },
    prepayAmount: { default: undefined },
    rapidChargerBaseOfCalculation: { default: "" },
    rapidChargerPrice: { default: 0 },
    validFrom: { default: "" },
    hideRegistrationCharge: { type: Boolean, default: false },
    guestCommission: { default: undefined },
    registrationCharge: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props

const i18n = useI18n()

const currencyLabel = computed(() => {
  return config.getCurrencyLabel(props.currency)
})

const formatPrice = (value: number) => {
  return PriceService.formatPrice(value, i18n)
}

const translatePricingUnit = (unit: string) => {
  return PriceService.translatePricingUnit(unit, i18n)
}

const __returned__ = { props, i18n, currencyLabel, formatPrice, translatePricingUnit, Card, get PriceService() { return PriceService }, get config() { return config }, computed, get useI18n() { return useI18n }, get format() { return format } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})